import {
	createPageSegmentLoadMetric,
	IN_EDITOR_TEMPLATES_SEGMENT_KEY,
} from '@confluence/browser-metrics';

export const IN_EDITOR_TEMPLATES_METRIC = createPageSegmentLoadMetric({
	key: IN_EDITOR_TEMPLATES_SEGMENT_KEY,
});
